import { useEffect, useState } from "react";

import { CookieNotice } from "components/widgets";

const LS_KEY = "cookie_notice";

export const CookieNoticeWrapper = (): JSX.Element => {
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    try {
      const value = localStorage.getItem(LS_KEY);

      if (value === null) {
        setShow(true);
      }
    } catch (e) {
      console.error("Local storage not available, not showing the cookie notice.");
    }
  }, []);

  const onOK = () => {
    localStorage.setItem(LS_KEY, "ok");
    setShow(false);
  };

  const onCancel = () => {
    localStorage.setItem(LS_KEY, "cancel");
    setShow(false);
  };

  if (!show) {
    return <></>;
  }

  return (
    <CookieNotice
      onOK={onOK}
      onCancel={onCancel}
    />
  );
};
